import { gql } from "apollo-boost"

export const createCommentInvoiceMonth = gql`
  mutation CreateInvoiceMonthComments(
    $monitoringFinancialInvoiceMonth: ID!, 
    $data: CreateMonitoringCommentInput!
  ){
    CreateInvoiceMonthComments(
      monitoringFinancialInvoiceMonth: $monitoringFinancialInvoiceMonth
      data: $data
    ){
      id
    }
  }
`
